import { pull } from 'lodash-es'
import { shallow } from 'zustand/shallow'
import { createWithEqualityFn } from 'zustand/traditional'
import { ModalName, ModalState } from './types'

const queue: ModalName[] = []

export const useModalStore = createWithEqualityFn<ModalState>(
  (set, get) => ({
    modal: undefined,
    modalParams: undefined,
    openModal: (requested, params) => {
      const current = get().modal
      if (current === requested || queue.includes(requested)) return false
      if (current) {
        queue.push(requested)
      } else {
        set({ modal: requested, modalParams: params })
      }
      return true
    },
    closeModal: (requested) => {
      const current = get().modal
      if (current === requested) {
        set({ modal: queue.shift(), modalParams: undefined })
      } else {
        pull(queue, requested)
      }
    },
  }),
  shallow,
)
